import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import { List, ListItem } from '@mui/material';
import { FC, PropsWithChildren } from 'react';
import { DragHandle } from '../../components/fullTable/DragHandle';

interface IStaticOptionListItem {
  item: any;
  id: string;
}
export const StaticOptionListItem: FC<PropsWithChildren<IStaticOptionListItem>> = ({
  item,
  id,
  children,
}) => {
  const classes = useStyles();
  return (
    <List dense className={classes.StyledStaticList}>
      <ListItem key={id} className={classes.StyledStaticListItem} style={{ cursor: 'grab' }}>
        <DragHandle />
        {children}
      </ListItem>
    </List>
  );
};

const useStyles = makeStyles<Theme>((theme: Theme) => ({
  StyledStaticList: {
    boxShadow: 'rgb(0 0 0 / 10%) 0px 20px 25px -5px, rgb(0 0 0 / 30%) 0px 10px 10px -5px',
    outline: '#005570 solid 1px',
    background: 'white',
  },
  StyledStaticListItem: {
    '&:first-of-type': {
      minWidth: '20ch',
    },
  },
}));
